/** imports
 *  ------------------------------------------------------------------------------------------------
 *  // THEMEREVIEW
 *  There's lots of common functionality here. Remove what's not needed!
 *  refer to init() for brief descriptions
**/
import { init as formsInit } from './modules/forms';
import { init as genericIntersectionInit } from './modules/generic-intersection';
import { init as carouselInit } from './modules/carousels';
import { init as expandableInit } from './modules/expandable';
import { init as stickyInit } from './modules/sticky';
import { init as overlayInit } from './modules/overlay';


/** Add body class for JS and feature detect intersection observers
 *  ------------------------------------------------------------------------------------------------
**/
document.documentElement.classList.replace('no-js', 'js');

// feature detect intersection observer
// we disable some styling and don't try to fade images if it's not supported
const gotIntersction = (
	('IntersectionObserver' in window)
	&& ('IntersectionObserverEntry' in window)
	&& ('intersectionRatio' in window.IntersectionObserverEntry.prototype)
	&& ('isIntersecting' in window.IntersectionObserverEntry.prototype)
);
document.documentElement.classList.add(gotIntersction ? 'got-intersection' : 'no-intersection');


/** Init everything that interacts with DOM (after dom is ready)
 *  ------------------------------------------------------------------------------------------------
**/
const init = () => {
	// validation listeners for forms
	formsInit();
	// allowing elements to opt in to generic interesection observation
	// by adding .js--wants-interestion
	genericIntersectionInit();
	// carousels
	carouselInit();
	// some focus and accessibility helpers for expandable content
	expandableInit();
	// stick .u-stick-if-possible elements to the top if possible
	stickyInit();
	// launching overlays
	overlayInit();
};


if (document.readyState === 'loading') { // Loading hasn't finished yet
	// DOMContentLoaded can sometimes fire very late...
	// it fires after all defer scripts are loaded
	// however the readystatechange changes to interactive BEFORE defer scripts fire...
	// document.addEventListener('DOMContentLoaded', init, false);
	document.addEventListener('readystatechange', (event) => {
		if (event.target.readyState === 'interactive') {
			init();
		}
		// event.target.readyState === 'complete' is available and equivelant to DOMContentLoaded
	});
} else { // readystate is already past loading
	init();
}
